import React, { createContext, useContext, useState } from 'react';

const AgencyAgentContext = createContext<IAgencyAgentContext | undefined>(undefined);

export interface IAgencyAgentContext {
    allAgencies: IAllAgencies[];
    setAllAgencies: React.Dispatch<React.SetStateAction<IAllAgencies[]>>;
    allAgents: IAllAgents[];
    setAllAgents: React.Dispatch<React.SetStateAction<IAllAgents[]>>;
    agenciesOptions: ILabelValue[];
    setAgenciesOptions: React.Dispatch<React.SetStateAction<ILabelValue[]>>;
    agentsOptions: ILabelValue[];
    setAgentsOptions: React.Dispatch<React.SetStateAction<ILabelValue[]>>;
}

interface IAllAgencies {
    agency_id: string;
    agency_name: string;
}

interface IAllAgents {
    agency_id: string;
    agency_name: string;
    agent_id: string;
    agent_name: string;
    contact_number: string | null;
    email: string | null;
}

interface ILabelValue {
    label: string;
    value: any;
}

export const AgencyAgentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [allAgencies, setAllAgencies] = useState<IAllAgencies[]>([]);
    const [allAgents, setAllAgents] = useState<IAllAgents[]>([]);
    const [agenciesOptions, setAgenciesOptions] = useState<ILabelValue[]>([]);
    const [agentsOptions, setAgentsOptions] = useState<ILabelValue[]>([]);

    const value = {
        allAgencies,
        setAllAgencies,
        allAgents,
        setAllAgents,
        agenciesOptions,
        setAgenciesOptions,
        agentsOptions,
        setAgentsOptions
    }

    return (
        <AgencyAgentContext.Provider value={value}>
            {children}
        </AgencyAgentContext.Provider>
    )
};

export const useAgencyAgentContext = () => {
    const agencyAgentContext = useContext(AgencyAgentContext);
    if (!agencyAgentContext) {
        throw new Error("useAgencyAgentContext must be used within AgencyAgentProvider")
    }
    return agencyAgentContext
}